import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './currentSessionQuery.gql';
import { SessionFragmentDoc } from '../../fragments/users/SessionFragment.generated';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
export type CurrentSessionQuery_currentSession_Session_calendarEventPops_CalendarEventPop = {
  __typename: 'CalendarEventPop',
  calendarEventId?: number | null,
  id: number,
  popType?: string | null
};

export type CurrentSessionQuery_currentSession_Session_pops_Pop = {
  __typename: 'Pop',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  popType: string
};

export type CurrentSessionQuery_currentSession_Session_reviews_Review = {
  __typename: 'Review',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  content?: string | null,
  locationId?: number | null
};

export type CurrentSessionQuery_currentSession_Session_reviewUpvotes_ReviewUpvote = {
  __typename: 'ReviewUpvote',
  id: number,
  reviewId?: number | null
};

export type CurrentSessionQuery_currentSession_Session_user_User_calendarEventPops_CalendarEventPop = {
  __typename: 'CalendarEventPop',
  id: number,
  calendarEventId?: number | null,
  popType?: string | null
};

export type CurrentSessionQuery_currentSession_Session_user_User_pops_Pop = {
  __typename: 'Pop',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  popType: string
};

export type CurrentSessionQuery_currentSession_Session_user_User_reviews_Review_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number
};

export type CurrentSessionQuery_currentSession_Session_user_User_reviews_Review = {
  __typename: 'Review',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  content?: string | null,
  locationId?: number | null,
  restaurant?: CurrentSessionQuery_currentSession_Session_user_User_reviews_Review_restaurant_Restaurant | null
};

export type CurrentSessionQuery_currentSession_Session_user_User_reviewUpvotes_ReviewUpvote = {
  __typename: 'ReviewUpvote',
  id: number,
  reviewId?: number | null
};

export type CurrentSessionQuery_currentSession_Session_user_User_followers_Follower_favoriteLocation_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  slug: string
};

export type CurrentSessionQuery_currentSession_Session_user_User_followers_Follower = {
  __typename: 'Follower',
  id: number,
  isSmsUnsubscribed?: boolean | null,
  isUnsubscribed?: boolean | null,
  restaurantId: number,
  favoriteLocation?: CurrentSessionQuery_currentSession_Session_user_User_followers_Follower_favoriteLocation_RestaurantLocation | null
};

export type CurrentSessionQuery_currentSession_Session_user_User = {
  __typename: 'User',
  id: number,
  adminPaletteType?: string | null,
  currentSignInAt?: string | null,
  orderAudioType?: string | null,
  authyStatus?: string | null,
  avatarUrl?: string | null,
  birthDay?: number | null,
  birthMonth?: number | null,
  createdAt?: string | null,
  displayName: string,
  email?: string | null,
  firstName?: string | null,
  fullName?: string | null,
  isPendingPassword?: boolean | null,
  isRoot: boolean,
  isRootStaging: boolean,
  isSmsUnsubscribed?: boolean | null,
  isTextValidated: boolean,
  isUnsubscribed?: boolean | null,
  lastFourDigitsPhoneNumber?: string | null,
  lastName?: string | null,
  phone?: string | null,
  isMobilePhone?: boolean | null,
  thumbnailUrl?: string | null,
  userRole?: string | null,
  calendarEventPops?: Array<CurrentSessionQuery_currentSession_Session_user_User_calendarEventPops_CalendarEventPop> | null,
  pops: Array<CurrentSessionQuery_currentSession_Session_user_User_pops_Pop>,
  reviews: Array<CurrentSessionQuery_currentSession_Session_user_User_reviews_Review>,
  reviewUpvotes: Array<CurrentSessionQuery_currentSession_Session_user_User_reviewUpvotes_ReviewUpvote>,
  followers: Array<CurrentSessionQuery_currentSession_Session_user_User_followers_Follower>
};

export type CurrentSessionQuery_currentSession_Session = {
  __typename: 'Session',
  id: string,
  avatarUrl?: string | null,
  isAuthyRequired: boolean,
  isAuthyVerified: boolean,
  isSoftAuthenticated: boolean,
  calendarEventPops: Array<CurrentSessionQuery_currentSession_Session_calendarEventPops_CalendarEventPop>,
  pops: Array<CurrentSessionQuery_currentSession_Session_pops_Pop>,
  reviews: Array<CurrentSessionQuery_currentSession_Session_reviews_Review>,
  reviewUpvotes: Array<CurrentSessionQuery_currentSession_Session_reviewUpvotes_ReviewUpvote>,
  user?: CurrentSessionQuery_currentSession_Session_user_User | null
};

export type CurrentSessionQuery_Query = {
  __typename?: 'Query',
  currentSession: CurrentSessionQuery_currentSession_Session
};


export type CurrentSessionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentSessionQuery = CurrentSessionQuery_Query;


export const CurrentSessionDocument = /*#__PURE__*/ document as unknown as DocumentNode<CurrentSessionQuery, CurrentSessionQueryVariables>;


/**
 * __useCurrentSessionQuery__
 *
 * To run a query within a React component, call `useCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param options options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentSessionQuery(options?: ApolloReactHooks.QueryHookOptions<CurrentSessionQuery, CurrentSessionQueryVariables>) {
                return ApolloReactHooks.useQuery<CurrentSessionQuery, CurrentSessionQueryVariables>(CurrentSessionDocument, options);
      }
export function useCurrentSessionLazyQuery(options?: ApolloReactHooks.LazyQueryHookOptions<CurrentSessionQuery, CurrentSessionQueryVariables>) {
                    return ApolloReactHooks.useLazyQuery<CurrentSessionQuery, CurrentSessionQueryVariables>(CurrentSessionDocument, options);
        }
export function useCurrentSessionSuspenseQuery(options?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentSessionQuery, CurrentSessionQueryVariables>) {
                    return ApolloReactHooks.useSuspenseQuery<CurrentSessionQuery, CurrentSessionQueryVariables>(CurrentSessionDocument, options);
        }
export type CurrentSessionQueryHookResult = ReturnType<typeof useCurrentSessionQuery>;
export type CurrentSessionLazyQueryHookResult = ReturnType<typeof useCurrentSessionLazyQuery>;
export type CurrentSessionSuspenseQueryHookResult = ReturnType<typeof useCurrentSessionSuspenseQuery>;
export type CurrentSessionQueryResult = ApolloReactCommon.QueryResult<CurrentSessionQuery, CurrentSessionQueryVariables>;